import palette from '../palette';

export default {
  paper: {
    backgroundColor: palette.white,
  },
};
